<form [formGroup]="kostenExtraGezinshulp">
    <div formArrayName="pgaKostenExtraGezinshulp">
        <div *ngFor="let item of pgaKostenExtraGezinshulp.controls; let i = index; "
             [formGroupName]="i" class="row">
            <snelstart-ui-text-form-control (change)="saveForm()"
                                            [label]="i === 0 ? 'Kosten extra gezinshulp' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
            >

            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Kosten' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijKostenExtraGezinshulp(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 icon="trash"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
        </div>
    </div>
</form>

<div *ngIf="pgaKostenExtraGezinshulp.length === 0">
    <snelstart-ui-button (click)="addRijKostenExtraGezinshulp()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Kosten extra gezinshulp
    </snelstart-ui-button>
</div>
<div *ngIf="pgaKostenExtraGezinshulp.length > 0">
    <snelstart-ui-button (click)="addRijKostenExtraGezinshulp()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Kosten extra gezinshulp toevoegen
    </snelstart-ui-button>
</div>



